/* eslint-disable react/no-multi-comp */
import React, { useContext } from 'react';
import { Row, Col, LoadingDots } from '@app/ui';
import { InVenueContext } from '../../InVenue.context';
import useGenderBreakdown from '../../../components/hooks/inVenue/useGenderBreakdown';
import { decimal, percentage, shortDate } from '../../../utils/formatters';

const GenderBreakdown = () => {
    const {
        client,
        current: { rightsholder, season, gameDates, sections },
        selectedDate,
        isLoadingFilters,
    } = useContext(InVenueContext);

    const { data: analytics, isLoading: isLoadingAnalytics } =
        useGenderBreakdown({
            clientId: client.id,
            rightsholder,
            season,
            gameDates: selectedDate ? [selectedDate] : gameDates,
            sectionIds: sections.map(section => section.id),
        });

    const femalePercentage =
        analytics.total && analytics.female
            ? analytics.female / analytics.total
            : 0;
    const malePercentage =
        analytics.total && analytics.male
            ? analytics.male / analytics.total
            : 0;

    const isLoading = isLoadingFilters || isLoadingAnalytics;

    return (
        <Row gutter={16} className="gds-flex">
            <Col md={24}>
                <div className="stadium-attendance-card -mb-10px">
                    <>
                        {isLoading && <LoadingDots />}
                        {!isLoading && (
                            <>
                                <p className="title">Total Attendance</p>
                                <p className="value">
                                    {decimal(analytics.total)} /{' '}
                                    {decimal(analytics.capacity)}
                                </p>
                                {selectedDate && (
                                    <p className="date gds-text--body-xs">
                                        {shortDate(selectedDate)}
                                    </p>
                                )}
                            </>
                        )}
                    </>
                </div>
            </Col>
            <Col md={12}>
                <div className="stadium-attendance-card">
                    {isLoading && <LoadingDots />}
                    {!isLoading && (
                        <>
                            <p className="title">Female Attendance</p>
                            <p className="value">
                                {decimal(analytics.female)}{' '}
                                <span>({percentage(femalePercentage)})</span>
                            </p>
                            {selectedDate && (
                                <p className="date gds-text--body-xs">
                                    {shortDate(selectedDate)}
                                </p>
                            )}
                        </>
                    )}
                </div>
            </Col>
            <Col md={12}>
                <div className="stadium-attendance-card">
                    {isLoading && <LoadingDots />}
                    {!isLoading && (
                        <>
                            <p className="title">Male Attendance</p>
                            <p className="value">
                                {decimal(analytics.male)}{' '}
                                <span>({percentage(malePercentage)})</span>
                            </p>
                            {selectedDate && (
                                <p className="date gds-text--body-xs">
                                    {shortDate(selectedDate)}
                                </p>
                            )}
                        </>
                    )}
                </div>
            </Col>
        </Row>
    );
};

export default GenderBreakdown;
